/**
 * ProfileNarrative — the practitioner's own summary of her practice.
 *
 * It replaces ProfileSummary, which rendered an LLM-written paragraph about the
 * user, its extracted topics and its "expertise indicators", each with a
 * confidence number, and offered a "regenerate" button. adr/0025 removed that
 * whole surface: `GET/POST /users/{id}/summary` is not a route this platform
 * serves, because nothing generates a summary of a colleague, and what the user
 * says about her own practice is a party attribute with exactly one writer,
 * herself.
 *
 * So there is no regenerate action here and no confidence anywhere. The card is
 * read-only; editing happens in the profile's own edit form beside every other
 * party attribute.
 *
 * Null and empty are not the same answer and neither is a gap: null is "she has
 * written none", which the empty state says in words, and the edit form is how
 * it stops being null.
 */

import { useTranslation } from 'react-i18next';

export function ProfileNarrative({ narrative }: { narrative: string | null }) {
  const { t } = useTranslation();

  return (
    <section
      aria-labelledby="profile-narrative-heading"
      className="rounded-xl border border-neutral-200 bg-white p-4 space-y-2"
    >
      <h2
        id="profile-narrative-heading"
        className="text-sm font-medium text-neutral-500"
      >
        {t('profile.narrative')}
      </h2>
      {narrative ? (
        <p className="text-base whitespace-pre-wrap text-neutral-900">{narrative}</p>
      ) : (
        <p className="text-sm text-neutral-500">{t('profile.narrativeEmpty')}</p>
      )}
    </section>
  );
}

export default ProfileNarrative;
